// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "default/js/" + chunkId + ".js?id=" + {"419":"94d4dd6e3be530933a64","527":"da82076fe3486326d2a0"}[chunkId] + "";
};